import React from "react";
import { Megaphone, Eye, Users, Leaf } from "lucide-react";

const benefits = [
  {
    icon: Megaphone,
    title: "Mini Walking Billboard",
    body: "Every bottle travels farther than you think — offices, gyms, homes, cars, events and beyond. Branding that moves.",
  },
  {
    icon: Eye,
    title: "Maximum Visibility",
    body: "Your logo stays front and center in the high-traffic moments that matter. Hands, tables, stages, and reels.",
  },
  {
    icon: Users,
    title: "Trust & Recognition",
    body: "Consistent exposure helps people remember, trust, and choose your brand at the moment of decision.",
  },
  {
    icon: Leaf,
    title: "Practical & Appreciated",
    body: "Everyone loves water. Your brand delivers real, tangible value with every sip — no throwaway swag.",
  },
];

export const Benefits = () => {
  return (
    <section
      data-testid="benefits-section"
      className="relative py-24 sm:py-32 bg-white border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div className="max-w-2xl">
            <div className="overline mb-4">The Marketing Benefits</div>
            <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-[0.95]">
              More than water.
              <br />
              <span className="font-editorial italic font-medium">
                It&apos;s your message in motion.
              </span>
            </h2>
          </div>
          <p className="text-slate-600 max-w-sm">
            We design, produce and ship branded bottles built to be photographed,
            shared and remembered.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {benefits.map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={b.title}
                data-testid={`benefit-card-${i}`}
                className="group relative bg-white border border-slate-200 rounded-2xl p-7 card-lift"
              >
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 rounded-2xl bg-[var(--tq-navy)] text-white flex items-center justify-center">
                    <Icon size={20} />
                  </div>
                  <span className="font-mono text-xs text-slate-400">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="font-display text-xl font-bold mb-3 tracking-tight">
                  {b.title}
                </h3>
                <p className="text-sm text-slate-600 leading-relaxed">{b.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
